var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 4.77431V21.6C17.9999 22.9255 16.9254 24 15.5999 24H2.4C1.07452 24 0 22.9255 0 21.6V2.4C0 1.07452 1.07452 0 2.4 0H12.802L17.9999 4.77431Z",
    fill: "url(#paint0_linear_2265_3915)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2265_3915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 4.77431H13.4018C13.0704 4.77431 12.8018 4.50568 12.8018 4.17431V0L17.9996 4.77431Z",
    fill: "#FECDCA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91366 19.3994V14.4994H4.74766C5.14433 14.4994 5.47333 14.5671 5.73466 14.7024C5.996 14.8377 6.18966 15.0197 6.31566 15.2484C6.44166 15.4771 6.50466 15.7384 6.50466 16.0324C6.50466 16.3031 6.444 16.5527 6.32266 16.7814C6.20133 17.0101 6.01 17.1967 5.74866 17.3414C5.48733 17.4814 5.15366 17.5514 4.74766 17.5514H3.85866V19.3994H2.91366ZM3.85866 16.7884H4.69166C4.995 16.7884 5.212 16.7207 5.34266 16.5854C5.478 16.4454 5.54566 16.2611 5.54566 16.0324C5.54566 15.7897 5.478 15.6031 5.34266 15.4724C5.212 15.3371 4.995 15.2694 4.69166 15.2694H3.85866V16.7884ZM7.21347 19.3994V14.4994H8.85147C9.4208 14.4994 9.8898 14.6021 10.2585 14.8074C10.6318 15.0081 10.9071 15.2927 11.0845 15.6614C11.2665 16.0254 11.3575 16.4547 11.3575 16.9494C11.3575 17.4441 11.2665 17.8757 11.0845 18.2444C10.9071 18.6084 10.6341 18.8931 10.2655 19.0984C9.8968 19.2991 9.42547 19.3994 8.85147 19.3994H7.21347ZM8.15847 18.5874H8.80247C9.2038 18.5874 9.5188 18.5221 9.74747 18.3914C9.9808 18.2607 10.1465 18.0741 10.2445 17.8314C10.3425 17.5841 10.3915 17.2901 10.3915 16.9494C10.3915 16.6041 10.3425 16.3101 10.2445 16.0674C10.1465 15.8201 9.9808 15.6311 9.74747 15.5004C9.5188 15.3697 9.2038 15.3044 8.80247 15.3044H8.15847V18.5874ZM12.1627 19.3994V14.4994H15.3547V15.2624H13.1077V16.5714H14.9067V17.3134H13.1077V19.3994H12.1627Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2265_3915",
    x: 11.0018,
    y: -0.6,
    width: 7.59824,
    height: 7.17441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.6,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2265_3915"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2265_3915",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2265_3915",
    x1: 15.5,
    y1: 1.5,
    x2: -7.50708e-8,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4336"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0e39c5af6ee4c5746d4b259aa3d42e62.svg";
export { ForwardRef as ReactComponent };